import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance29ub64y89bvyi as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      static a44(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.s43_1 = operation;
        $this.t43_1 = requestUuid;
        $this.u43_1 = data;
        $this.v43_1 = errors;
        $this.w43_1 = extensions;
        $this.x43_1 = exception;
        $this.y43_1 = Companion_getInstance().p42_1;
        $this.z43_1 = false;
        return $this;
      }
      static b44(operation, requestUuid) {
        return this.a44(operation, requestUuid, null, null, null, null);
      }
      c44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.y43_1 = this.y43_1.d44(executionContext);
        return this;
      }
      e44(data) {
        // Inline function 'kotlin.apply' call
        this.u43_1 = data;
        return this;
      }
      f44(errors) {
        // Inline function 'kotlin.apply' call
        this.v43_1 = errors;
        return this;
      }
      g44(exception) {
        // Inline function 'kotlin.apply' call
        this.x43_1 = exception;
        return this;
      }
      h44(extensions) {
        // Inline function 'kotlin.apply' call
        this.w43_1 = extensions;
        return this;
      }
      q42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.t43_1 = requestUuid;
        return this;
      }
      i44(isLast) {
        // Inline function 'kotlin.apply' call
        this.z43_1 = isLast;
        return this;
      }
      n37() {
        var tmp1_operation = this.s43_1;
        var tmp2_requestUuid = this.t43_1;
        var tmp3_data = this.u43_1;
        var tmp4_executionContext = this.y43_1;
        var tmp0_elvis_lhs = this.w43_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.v43_1;
        var tmp7_exception = this.x43_1;
        var tmp8_isLast = this.z43_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.j44_1 = requestUuid;
        this.k44_1 = operation;
        this.l44_1 = data;
        this.m44_1 = errors;
        this.n44_1 = exception;
        this.o44_1 = extensions;
        this.p44_1 = executionContext;
        this.q44_1 = isLast;
      }
      r44() {
        var tmp;
        if (this.f45()) {
          throw ApolloGraphQLException().e45(first(ensureNotNull(this.m44_1)));
        } else if (!(this.n44_1 == null)) {
          throw DefaultApolloException().x44('An exception happened', this.n44_1);
        } else {
          tmp = this.s44();
        }
        return tmp;
      }
      s44() {
        var tmp0_elvis_lhs = this.l44_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().k45(this.n44_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      f45() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.m44_1;
        return !(this_0 == null || this_0.s1());
      }
      q43() {
        return Builder().a44(this.k44_1, this.j44_1, this.l44_1, this.m44_1, this.o44_1, this.n44_1).c44(this.p44_1).i44(this.q44_1);
      }
      toString() {
        var tmp = 'operationName=' + this.k44_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.l44_1 == null ? 'null' : this.k44_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.m44_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.n44_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.n44_1).o1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
  ApolloResponse as ApolloResponse1aeginapbuksm,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
